var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0698 8.51001L9.50978 4.23001C3.75978 1.35001 1.39978 3.71001 4.27978 9.46001L5.14978 11.2C5.39978 11.71 5.39978 12.3 5.14978 12.81L4.27978 14.54C1.39978 20.29 3.74978 22.65 9.50978 19.77L18.0698 15.49C21.9098 13.57 21.9098 10.43 18.0698 8.51001ZM14.8398 12.75H9.43977C9.02978 12.75 8.68977 12.41 8.68977 12C8.68977 11.59 9.02978 11.25 9.43977 11.25H14.8398C15.2498 11.25 15.5898 11.59 15.5898 12C15.5898 12.41 15.2498 12.75 14.8398 12.75Z",
    fill: "#FF7D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.15070950a1453d94bcb19022ce6043a7.svg";
export { ForwardRef as ReactComponent };